import positionToStringId from '../../utils/positionToStringId.js';
import getRankByAdjacentUnits from './getRankByAdjacentUnits.js';
import getRankByEnemyDistance from './getRankByEnemyDistance.js';
import { isSamePosition } from '@wareena/game-algorithms';
const isHexEmpty = (position, allUnits) => {
    return allUnits.find((u) => isSamePosition(u.position, position)) ? false : true;
};
function rankNeighbourPositions({ allUnits, agentSide, rules, hexProperties, }) {
    const rankedPositions = {};
    const agentUnits = allUnits.filter((u) => u.side === agentSide);
    const enemyUnits = allUnits.filter((u) => u.side !== agentSide);
    agentUnits.forEach((unit) => {
        const neighbours = rules.getExistingNeighbours(unit.position);
        neighbours.forEach((neighbour) => {
            const stringId = positionToStringId(neighbour);
            if (isHexEmpty(neighbour, allUnits) && rankedPositions[stringId] === undefined) {
                rankedPositions[stringId] = {
                    row: neighbour.row,
                    column: neighbour.column,
                    rank: 0,
                };
            }
        });
    });
    Object.values(rankedPositions).forEach((rankedPosition) => {
        rankedPosition.rank += getRankByAdjacentUnits(rankedPosition, allUnits, rules, agentSide);
        rankedPosition.rank += getRankByEnemyDistance(rankedPosition, enemyUnits, allUnits, hexProperties, rules);
    });
    return Object.values(rankedPositions);
}
export default rankNeighbourPositions;
